
import React from "react";
import { TrendingUp } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import CollapsibleSection from "@/components/dashboard/CollapsibleSection";
import RecentResultsChart from "@/components/dashboard/RecentResultsChart";
import { PuttingResult } from "@/types/puttingResults";
import { useTranslation } from "react-i18next";

interface RecentResultsSectionProps {
  isCollapsed: boolean;
  onToggle: () => void;
  recentResults: PuttingResult[];
  isLoading?: boolean;
}

const RecentResultsSection: React.FC<RecentResultsSectionProps> = ({ 
  isCollapsed, 
  onToggle, 
  recentResults,
  isLoading = false
}) => {
  const { t } = useTranslation('dashboard');
  
  return (
    <CollapsibleSection 
      title={t('sections.recentResults')} 
      icon={<TrendingUp className="text-golf-600" />} 
      isCollapsed={isCollapsed} 
      onToggle={onToggle}
    >
      <div className="grid grid-cols-1 gap-4">
        {isLoading ? (
          <Skeleton className="w-full h-[300px] rounded-lg" />
        ) : (
          <RecentResultsChart recentResults={recentResults} />
        )}
      </div>
    </CollapsibleSection>
  );
};

export default RecentResultsSection;
